function compareValues(left, right, property) {
  if (property === 'acquisition_date') {
    var leftMissing = left === null || left === undefined || left === ''
    var rightMissing = right === null || right === undefined || right === ''

    // Match the database's ascending ORDER BY behavior: NULL dates come first.
    if (leftMissing || rightMissing) {
      if (leftMissing && rightMissing) return 0
      return leftMissing ? -1 : 1
    }

    var leftTime = new Date(left).getTime()
    var rightTime = new Date(right).getTime()
    if (!isNaN(leftTime) && !isNaN(rightTime)) {
      if (leftTime > rightTime) return 1
      if (leftTime < rightTime) return -1
      return 0
    }
  }

  if (left > right) return 1
  if (left < right) return -1
  return 0
}

export function dynamicSort(property, property2) {
  var sortOrder = 1
  if (property[0] === '-') {
    sortOrder = -1
    property = property.substr(1)
  }

  return function (a, b) {
    var result = compareValues(a[property], b[property], property)
    if (result !== 0) return result * sortOrder
    if (!property2) return 0
    return compareValues(a[property2], b[property2], property2)
  }
}



// WEBPACK FOOTER //
// ./src/utils/artworkSort.js